import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import Profile from '../pages/profiile/Profile';
import JobsApplied from '../pages/jobs/JobsApplied';
import JobDetails from '../pages/open_positions/JobDetails';
import Documents from '../pages/documents/DocumentsUpload';
import Status from '../pages/status/Status';
import Reset from '../pages/authentication/ResetPassword';
import AccountRecovery from '../pages/authentication/AccountRecovery';
import Home from '../pages/home/Home';
import Login from '../pages/authentication/Login';
import ThankYou from '../pages/thankyou/ThankYou';

const Routing = (props) => {
  const ROUTES = useRoutes([
    { path: '/', element: <Navigate to={'login'} /> },
    { path: '/login', element: <Login /> },
    { path: '/password-reset', element: <Reset /> },
    { path: '/account-recovery', element: <AccountRecovery /> },
    { path: '/jobs/job-details', element: <JobDetails {...props} /> },
    { path: '/thank-you', element: <ThankYou /> },
    {
      path: '/',
      element: <Home {...props} />,
      children: [
        { path: 'profile', element: <Profile /> },
        { path: 'jobs', element: <JobsApplied /> },
        { path: 'documents', element: <Documents /> },
        { path: 'status', element: <Status /> },
      ],
    },
  ]);
  return <React.Fragment>{ROUTES}</React.Fragment>;
};

export default Routing;
